// action type alanları burada olacak

const APPROVAL_MODAL = 'APPROVAL_MODAL';
const EDIT_POST_MODAL = 'EDIT_POST_MODAL';
const INTERESTS_MODAL = 'INTERESTS_MODAL';
const POST_LIKES_MODAL = 'POST_LIKES_MODAL';
const MY_POSTS = 'MY_POSTS';
const MY_COMMENT = 'MY_COMMENT';
const USER_INFO = 'USER_INFO';
export { APPROVAL_MODAL, EDIT_POST_MODAL, INTERESTS_MODAL, POST_LIKES_MODAL, MY_POSTS, MY_COMMENT, USER_INFO };
